import React, { useState, useEffect } from "react";

import { Descriptions, Form, Modal,Col,Row } from "antd";
import { EditOutlined, PlusSquareOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EvidenzEmailEdit } from "./EvidenzEmailEdit.jsx";
import { DeleteConfirmationModal } from "../Helper/DeleteConfirmationModal";


export const EvidenzDatenEmails = ({
  aktEvadrRecNr,
  setTitel,
  gruppe,
  headName,
}) => {
  const [url1, setUrl1] = useState("");
  const [url2, setUrl2] = useState("");
  const [emailRecNr, setEmailRecNr] = useState(0);
  const { user, logoutLogin, apiBaseUrl } = LayoutData();
  const [editDaten, setEditDaten] = useState();
  const [items, setItems] = useState();
  const [modalOpen, setModalOpen] = useState();
  const [modalOpen2, setModalOpen2] = useState();
  const [form] = Form.useForm();
  const [modatTitel, setModatTitel] = useState();
  const queryClient = useQueryClient();

  useEffect(() => {
    setTitel(
      <>
      <Row justify="space-between" align="middle" >
        <Col>
        {headName}{" "}
        </Col>
        <Col>
        <span
          onClick={handleAddEmailRecord}
          style={{ cursor: "pointer", fontSize: 23, marginTop: 3 }}
        >
          <PlusSquareOutlined />
        </span>
        </Col>
        </Row> 
      </>
    );
  }, []);

  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    if (apiBaseUrl && aktEvadrRecNr !== 0) {
      setUrl1(
        `${apiBaseUrl}api/getEvEmails?evrecnr=${aktEvadrRecNr}&art=${gruppe}`
      );
    }
  }, [apiBaseUrl, aktEvadrRecNr, gruppe]);

  useEffect(() => {
    if (apiBaseUrl && emailRecNr !== 0) {
      setUrl2(`${apiBaseUrl}api/getEvEmails?recnr=${emailRecNr}&art=${gruppe}`);
    }
  }, [apiBaseUrl, emailRecNr, gruppe]);
  const {
    isPending: isPending1,
    error: error1,
    data: evEMailData,
    refetch: refetchEmailData1,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) => {
          if (res.status === 401) logoutLogin();
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        return []; //Promise.resolve({});
      }
    },
  });
  if (error1) {
    console.log("url1", url1);
    console.error("Error", error1);
  }
  useEffect(() => {
    if (evEMailData && Array.isArray(evEMailData)) {
      //setTitel(<>{evEMailData.length} Kontakte am Standort</>);
      console.log("EvEMailData", evEMailData);
      /*
      const newData = aconkundenData.map((item, index) => ({
        ...item,
        key: index,
      }));
      */
      const itemsData = [];
      const add = (title, text, recnr, modalTitel) => {
        itemsData.push({
          label: (
            <>
              <span
                onClick={() => {
                  handleOnEditClick(recnr, modalTitel);
                }}
                style={{ cursor: "pointer" }}
              >
                <EditOutlined style={{ fontSize: 20 }} />
              </span>
              {title}
            </>
          ),
          children: <>{text}</>,
          key: itemsData.length,
        });
      };
      evEMailData.map((item, index) => {
        add(
          `${item.titel} ${item.vorname} ${item.name} ${item.grad}`,
          item.email,
          item.recnr,
          `${item.vorname} ${item.name}`
        );
        return null;
      });

      setItems(itemsData);
      //checkMainContainerHeight();
    }
  }, [evEMailData]);
  const {
    isPending: isPending2,
    error: error2,
    data: emailData,
  } = useQuery({
    queryKey: [url2],
    queryFn: () => {
      if (url2) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url2, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) => {
          if (res.status === 401) logoutLogin();
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        return []; //Promise.resolve({});
      }
    },
  });
  if (error2) {
    console.log("url2", url2);
    console.error("Error2", error2);
  }

  useEffect(() => {
    if (modalOpen && emailData) {
      emailRecNr !== 0 ? setEditDaten(emailData) : setEditDaten(null);
      console.log("emailData -> edit", emailData);
    }
  }, [emailData, modalOpen]);

  const handleOnEditClick = (recnr, titel) => {
    setModatTitel(`${titel} (${recnr})`);
    setEmailRecNr(recnr);
    setModalOpen(true);
  };
  const handleAddEmailRecord = () => {
    //console.log("Neuanlage");
    //evEMailData.recnr=0;
    setModatTitel("Neuanlage");
    setEmailRecNr(0);
    setModalOpen(true);
  };
  const convert01 = (saveDaten, propName) => {
    if (saveDaten && saveDaten.hasOwnProperty(propName)) {
      saveDaten[propName] = saveDaten[propName] ? 1 : 0;
    }
  };
  const handleFinish = async (values) => {
    console.log("handleFinish", values);
    // hier sollen die Änderungen gespeichert werden
    let saveDaten = {};
    if (editDaten === null) {
      saveDaten = values;
      saveDaten["recnr"] = 0;
    } else {
      //console.log("********************");
      for (const key in values) {
        if (
          values.hasOwnProperty(key) &&
          (editDaten === null || editDaten.hasOwnProperty(key))
        ) {
          if (editDaten === null || values[key] !== editDaten[key]) {
            // Der Wert des Schlüssels hat sich geändert
            //console.log(key, aktvalues[key], daten[key]);
            saveDaten[key] = values[key];
          }
        }
      }
      saveDaten["recnr"] = editDaten.recnr;
    }

    saveDaten["evrec"] = aktEvadrRecNr;
    saveDaten["art"] = gruppe;
    convert01(saveDaten, "liveupd"); // Wenn in der DB 01 erwartet wird
    console.log("saveDaten", saveDaten);
    const respone = await postEvEmailDaten(saveDaten, apiBaseUrl, user.bearer);
    console.log("respone", respone);
    setModalOpen(false);
    // Annahme: Du hast eine Query mit dem Key 'meineDaten'
    queryClient.removeQueries(url2);
    refetchEmailData1();
  };

  const postEvEmailDaten = async (data, baseUrl, bearer) => {
    const response = await fetch(`${baseUrl}api/evemails/saveJson`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearer}`,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  };
  const deleteEvEmailDaten = async (recnr, baseUrl, bearer) => {
    const response = await fetch(`${baseUrl}api/evemails/delete?recnr=${recnr}&art=${gruppe}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearer}`,
      },
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
  };

  const handleDelete = async() => {
    setModalOpen2(false)
    //console.log("Delete Datensatz");
    setModalOpen(false);
     await deleteEvEmailDaten(emailRecNr, apiBaseUrl, user.bearer);
    refetchEmailData1();
  };

  return (
    <>
      <Descriptions
        //title="User Info"
        items={items}
        column={1}
        size="small"
        bordered={true}
        loading={isPending1.toString()}
      />
      <Modal
        title={modatTitel}
        loading={isPending2.toString()}
        width={400}
        centered
        open={modalOpen}
        //cancelText="Schließen"
        onCancel={() => {
          setModalOpen(false);
        }}
        //onOk={() => form.submit()}
        //okText="Speichern"
        okButtonProps={{ style: { display: "none" } }} // Hier wird der OK-Button ausgeblendet
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <EvidenzEmailEdit
          editDaten={editDaten}
          handleFinish={handleFinish}
          handleDelete={()=>setModalOpen2(true)}
        />
      </Modal>
      <DeleteConfirmationModal
        title="Email Kontakt unwiederruflich löschen"
        text="Möchten Sie diesen Email Kontakt wirklich löschen?"
        visible={modalOpen2}
        onConfirmDelete={handleDelete}
        onCancel={() => setModalOpen2(false)}
      />
    </>
  );
};

/*
 
*/
